import { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import PostingsOzonApi from '../../../API/shipment/postingsOzon-api';
import PostingsWbApi from '../../../API/shipment/postingsWb-api';
import PostingsYandexApi from '../../../API/shipment/postingsYandex-api';
import ReturnsApi from '../../../API/shipment/returns-api';
import { Column, NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Content } from '../../../components/Basic/Global';
import { DateInput, Input, InputLabel, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader, TablePagination } from '../../../components/Basic/Table';
import { H1, Text } from '../../../components/Basic/WrapsStyle';
import {
  MAP_SKLAD_RUS,
  MAP_SKLAD_RUS_ALL,
  MARKETS_ALL,
  RETURN_STATUS_LIST,
  SKLAD_LIST,
  TYPE_RETURNS
} from '../../../constans';
import ReturnsLine from './Line';
import styles from './styles.module.scss';

const SHOPS = {
  ozon: ['Все', 'ozon1', 'ozon2', 'ozon3', 'ozon4', 'ozon5', 'ozon6', 'ozon7'],
  yandex: ['Все', 'yandex1', 'yandex3', 'yandex4', 'yandex5', 'yandex6', 'yandex7', 'yandex8'],
  wb: ['Все', 'wb1', 'wb2', 'wb3', 'wb4', 'wb5', 'wb6', 'wb7'],
  megamarket: ['Все', 'megamarket1', 'megamarket2'],
  Ozon: ['Все', 'ozon1', 'ozon2', 'ozon3', 'ozon4', 'ozon5', 'ozon6', 'ozon7'],
  Yandex: ['Все', 'yandex1', 'yandex3', 'yandex4', 'yandex5', 'yandex6', 'yandex7', 'yandex8'],
  Wb: ['Все', 'wb1', 'wb2', 'wb3', 'wb4', 'wb5', 'wb6', 'wb7'],
  Megamarket: ['Все', 'megamarket1', 'megamarket2'],
};

export const MARKETS_LIST = ['Не выбрана', 'Ozon', 'Wb', 'Yandex', 'Megamarket', 'Avito'];;

export const WIDTH_POSTING = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '200px', // 3
  '180px', // 4
  '127px', // 5
  '120px', // 6
  '220px', // 7
  '100px', // 8
  '40px', // 9
  '100px', // 10
  '220px', // 11
  '80px', // 12
  '210px', // 13
];

const STATUSES = ['Не выбран', 'Нет в наличии', 'Резерв', 'Частичный резерв', 'Излишки', 'Не хватает'];

const STATUSES_ORDERS_WB = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Прибыл на ПВЗ',
  'Продано',
  'Отменено',
  'Отменено клиентом',
  'Обнаружен брак',
];

const STATUSES_ORDERS_OZON = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Продано',
  'Не принят на CЦ',
  'Арбитраж',
  'Отменено',
];

const STATUSES_ORDERS_YANDEX = ['Не выбран', 'Ожидает отгрузки', 'Доставляется', 'Продано', 'Отменено'];

const STATUSES_ORDERS_SBER = ['Не выбран', 'Ожидает отгрузки', 'Доставляется', 'Продано', 'Отменено'];
const STATUSES_ORDERS = {
  Ozon: STATUSES_ORDERS_OZON,
  Yandex: STATUSES_ORDERS_YANDEX,
  Wb: STATUSES_ORDERS_WB,
  SBER: STATUSES_ORDERS_SBER,
  'Не выбрана': [
    'Не выбран',
    'Ожидает отгрузки',
    'Доставляется',
    'Продано',
    'Прибыл на ПВЗ',
    'Не принят на CЦ',
    'Арбитраж',
    'Отменено',
    'Отменено клиентом',
    'Обнаружен брак',
  ],
};

const STATUSES_RETURNS = [];

const FILTER = {
  0: 'all',
  1: 'awaiting_confirm',
  2: 'confirmed',
  3: 'variance',
  4: 'return_mp',
  5: 'doubles',
};

const CalcMonthAgo = () => {
  const start = new Date();
  start.setTime(start.getTime() - 30 * 24 * 3600000);

  return start;
};

const CalcFeatureTwoDay = () => {
  const start = new Date();
  start.setTime(start.getTime() + 2 * 24 * 3600000);
  return start;
};

function ReturnsEntry() {
  const user = useSelector((store) => store.user);
  const [sklad, setSklad] = useState(SKLAD_LIST[0]);
  const [skladReturn, setSkladReturn] = useState(SKLAD_LIST[0]);

  const [market, setMarket] = useState(MARKETS_LIST[0]);

  const [period, setPeriod] = useState({ start: CalcMonthAgo(), end: CalcFeatureTwoDay() });

  const [returns, setReturns] = useState({ ids: [], byId: {} });
  const [map, setMap] = useState({});
  const [warehouseMap, setWarehouseMap] = useState({});

  const [entriedProductsMap, setEntriedProductsMap] = useState({});

  const useFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      // eslint-disable-next-line no-unused-expressions
      htmlElRef.current && htmlElRef.current.focus();
      // eslint-disable-next-line no-unused-expressions
      htmlElRef.current && htmlElRef.current.select();
    };

    return [htmlElRef, setFocus];
  };

  const [inputRef, setInputFocus] = useFocus();

  const [count, setCount] = useState([]);
  const [page, setPage] = useState(1);

  const [show, setShow] = useState(20);
  const [search, setSearch] = useState('');

  const [countStock, setCountStock] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [provider, changeProvider] = useState({ name: 'Не выбран', id: null });
  const allProviders = useSelector((store) => store.providers);
  const [providers, setProviders] = useState([]);
  const [typeReturn, setTypeReturn] = useState(TYPE_RETURNS[0]);

  const [postingsMap, setPostingMap] = useState({});

  const [orderStatus, changeOrderStatus] = useState('Не выбран');
  const [shop, setShop] = useState('Все');

  const [shopMm, setShopMm] = useState(MARKETS_ALL.megamarket[0]);
  const [shopWb, setShopWb] = useState(MARKETS_ALL.wb[0]);

  const onChangePage = (v) => {
    setPage(v);
  };

  const onChangeTab = (n) => {
    setTab(n);
  };

  const onChangeReturn = (returnId, shop, productId, field, value) => {
    ReturnsApi.changeProductInReturn({
      data: {
        returnId,
        shop,
        productId,
        field,
        value,
      }
    })
      .then((r) => r.return)
      .then((r) => {
        setReturns({ ...returns, byId: { ...returns.byId, [r._id]: r } });
        console.log(r);
      });
  };
  const addProductToEntry = async (data) => {
    setInputFocus();

    await ReturnsApi.addReturn({ data }).then((r) => {
      setReturns({ ...returns, byId: { ...returns.byId, [r.return._id]: r.return } });
      setEntriedProductsMap({ ...entriedProductsMap, [r.return._id]: r.entriedProduct });

      console.log(r);
    });
  };

  const params = useMemo(() => {
    return {
      tab: FILTER[tab],
      limit: parseInt(show),
      search: search.trim(),
      providerId: provider.id,
      type: 'return',
      market: market === 'Не выбрана' ? undefined : market.toLowerCase(),
      shop: shop === 'Все' ? undefined : shop.toLowerCase(),
      period: {
        startDate: period.start,
        endDate: period.end,
      },
      skladName: sklad === 'Все' ? undefined : MAP_SKLAD_RUS[sklad],
      skladReturn: skladReturn === 'Все' ? undefined : MAP_SKLAD_RUS_ALL[skladReturn],
      filters: {
        returnStatus: orderStatus === 'Не выбран' ? undefined : orderStatus,
        productsStatus: status === 'Не выбран' ? undefined : status,
        returnType: typeReturn === 'Не выбран' ? undefined : typeReturn,
      },
    };
  }, [tab, show, search, provider.id, market, shop, status, orderStatus, period, sklad, typeReturn, skladReturn]);

  const loadData = () => {
    ReturnsApi.getReturnItems({ data: params })
      .then((res) => {
        const { returns, cardsMap = {}, all_count = {}, count = 0, warehouseProductsMap = {} } = res;

        const { all, awaiting_confirm, confirmed, variance, return_mp, doubles } = all_count;
        setCount(count);
        setCountStock([all, awaiting_confirm, confirmed, variance, return_mp, doubles]);
        const ids = returns.map((item) => item._id);
        let byIds = {};
        returns.forEach((item) => (byIds[item._id] = item));

        setReturns({ ids, byId: byIds });
        setMap(cardsMap);
        setPostingMap(res.postingsMap);

        setWarehouseMap(warehouseProductsMap);
        setEntriedProductsMap(res.entriedProductsMap);
      })
      .catch();
  };

  useEffect(() => {
    loadData();
  }, [params]);

  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    if (p.length > 0) {
      setProviders([{ name: 'Не выбран', id: null }, ...p]);
      changeProvider({ name: 'Не выбран', id: null });
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  useEffect(() => {
    setShop('Все');
  }, [market]);

  const ozonReturns = () => {
    PostingsOzonApi.loadReturns({})
  };

  const yandexReturns = () => {
    PostingsYandexApi.loadReturns({})
  };

  const wbReturns = () => {
    PostingsWbApi.loadReturns({})

  };

  console.log(entriedProductsMap);
  return (
    <Content>
      <H1>Обработка возвратов</H1>

      <WhiteBlock className={styles.search_block}>
        <Row className={styles.navigate_table}>
          <NavTabs
            open_tab={tab}
            tabs={['Все возвраты', 'Ожидают занесения', 'Занесены', 'Расхождения', 'Возвраты на склад МП']}
            isNum={true}
            num={countStock}
            style_tab={styles.style_tab}
            onChange={onChangeTab}
          />
        </Row>
        <Input
          value={search}
          ref={inputRef}
          onBlur={(v) => setSearch(v)}
          onClickEnter={(v) => setSearch(v)}
          label="Поиск"
        />
        <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>

        <Row spaceBetween={true}>
          <Row style={{ height: '40px' }}>
            <div>
              <Select
                label="Показать на странице"
                select={show}
                list={['20', '50', '100', '150', '200', '500', '1000']}
                onSelect={(v) => setShow(v)}
                width="150px"
                style={{ marginRight: '15px' }}
              />
            </div>

            <Select
              list={MARKETS_LIST}
              select={market}
              label="Площадка"
              onSelect={(v) => setMarket(v)}
              width={'150px'}
              style={{ marginRight: '15px' }}
            />
            <Select
              list={SHOPS[market]}
              select={shop}
              disabled={market === MARKETS_LIST[0]}
              label="Магазин"
              onSelect={(v) => setShop(v)}
              width={'150px'}
              style={{ marginRight: '15px' }}
            />
            <Select
              label="Поставщик"
              select={provider}
              valueFn={(p) => p.name}
              list={providers}
              width="200px"
              onSelect={(v) => changeProvider(v)}
              style={{ marginRight: '15px' }}
            />
            <Select
              list={SKLAD_LIST}
              select={sklad}
              label="Склад отгрузки"
              onSelect={(v) => setSklad(v)}
              width={'200px'}
              style={{ marginRight: '15px' }}
            />
            <Select
              list={[...SKLAD_LIST, 'Маркетплейс', 'Не определен']}
              select={skladReturn}
              label="Склад возврата"
              onSelect={(v) => setSkladReturn(v)}
              width={'200px'}
              style={{ marginRight: '15px' }}
            />

            <Select
              label="Тип возврата"
              select={typeReturn}
              list={TYPE_RETURNS}
              width="200px"
              onSelect={(v) => setTypeReturn(v)}
              style={{ marginRight: '15px' }}
            />
            <Select
              label="Статус возврата"
              select={orderStatus}
              list={RETURN_STATUS_LIST}
              width="200px"
              onSelect={(v) => changeOrderStatus(v)}
            />
          </Row>

          <Row>
            <Column style={{ marginRight: '10px' }}>
              <InputLabel>Начало периода</InputLabel>
              <Row style={{ width: '130px' }}>
                <DateInput
                  value={period.start}
                  className={styles.calendar}
                  onChange={(v) => setPeriod({ ...period, start: new Date(v) })}
                />
              </Row>
            </Column>
            <Column style={{ marginRight: '10px' }}>
              <InputLabel>Конец периода</InputLabel>
              <Row style={{ width: '130px' }}>
                <DateInput
                  value={period.end}
                  className={styles.calendar}
                  onChange={(v) => setPeriod({ ...period, end: new Date(v) })}
                />
              </Row>
            </Column>
          </Row>
        </Row>
      </WhiteBlock>

      <Table styles={styles.table}>
        <TableHeader whiteHeader>
          <HeaderTitle width={WIDTH_POSTING[0]}>Номер возврата / заказа</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[12]} centerText>
            Дата возврата
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[1]}>Позиции в заказе</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>Артикул</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[10]} centerText={true}>
            Количество
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[7]} centerText={true}>
            Занесение
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[7]} centerText={true}>
            Расхождение
          </HeaderTitle>
          {isOwner && (
            <HeaderTitle width={WIDTH_POSTING[10]} centerText={true}>
              Цена продажи
            </HeaderTitle>
          )}
          <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
            Статус занесения
          </HeaderTitle>

          <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
            Поставщик
          </HeaderTitle>

          <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
            Тип возврата
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
            Статус возврата
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[1]}>Причина возврата / Адрес получения</HeaderTitle>
        </TableHeader>
        {returns.ids.map((id) => {
          const entriedProduct = entriedProductsMap[id];
          return (
            <ReturnsLine
              order={returns.byId[id]}
              map={map}
              isOwner={isOwner}
              postingsMap={postingsMap}
              key={returns.byId[id]._id}
              onChangeReturn={onChangeReturn}
              addProductToEntry={addProductToEntry}
              tab={tab}
              entriedProduct={entriedProduct}
            />
          );
        })}
      </Table>
      <TablePagination num={Math.ceil(count / show) || 1} show={page} onChange={onChangePage} />
    </Content>
  );
}

export default ReturnsEntry;
